// extracted by mini-css-extract-plugin
export var videoOverlay = "VideoPlayer-module--videoOverlay--1caqI";
export var coverImageShade = "VideoPlayer-module--coverImageShade--2YnUT";
export var coverImage = "VideoPlayer-module--coverImage--2jAvF";
export var btnWrapper = "VideoPlayer-module--btnWrapper--27onu";
export var reactPlayer = "VideoPlayer-module--reactPlayer--21lYG";